// extracted by mini-css-extract-plugin
export default {"mindGrid":"MindGrid__mindGrid___JOFCZ"};